// export this package's api
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-align@2.3.5@rc-align/es/index.js
// module id = null
// module chunks = 